import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Session } from '@models/session';
import { CloseOverlayKeyboardDirective, CloseOverlayAfterDirective } from '../../directives/close-overlay.directives';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lv-done-auditing',
  templateUrl: 'done-auditing.component.html',
  styleUrls: ['done-auditing.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CloseOverlayKeyboardDirective, CloseOverlayAfterDirective, TranslateModule]
})
export class DoneAuditingComponent {
  @Input() session: Session;
  @Input() passOrFail: string;
}
